<template>
  <canvas width="100%" height="275"></canvas>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    labels: {},
    values: {},
    color: {
      default: "rgba(20,220,120,0.2)"
    }
  },
  mounted() {
    let chartData = {
      datasets: [
        {
          data: this.$store.getters["campaigns/pieChartData"],
          backgroundColor: [
            "#0074D9",
            "#FF851B",
            "#FF4136",
            "#2ECC40",
            "#7FDBFF"
          ]
        }
      ],

      // These labels appear in the legend and in the tooltips when hovering different arcs
      labels: ["Clicked", "Opened", "Bounced", "Sent", "Unsubscribed"]
    };

    new Chart(this.$el.getContext("2d"), {
      type: "pie",
      data: chartData,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: true
        },
        legend: {
          display: true
        }
      }
    });
  }
};
</script>